import React, { useState } from "react";
import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import "./DeleteAccount.css";
import { WinnersHeaderBlue } from "../View/WinnersHome/WinnerBlueLan/WinnersHeaderBlue";

const DeleteAccount = () => {
  const navigate = useNavigate();

  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");

    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleDeleteAccount = async (e) => {
    e.preventDefault();

    if (!mobileNumber) {
      toast.error("Please enter your mobile number");
      return;
    }

    if (mobileNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        "https://api.thewinners2.in/api/v1/delete-account",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobileNumber: mobileNumber,
          }),
        }
      );

      const data = await response.json();

      if (data?.status) {
        toast.success(
          data?.message ||
            "Your account deletion request has been submitted."
        );

        setMobileNumber("");

        // Optional redirect after successful request
        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        toast.error(
          data?.error ||
            data?.message ||
            "Unable to process your request."
        );
      }
    } catch (error) {
      console.error("Delete account error:", error);

      toast.error(
        "Something went wrong. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="ws-delete-page">
      <WinnersHeaderBlue />

      {/* Background decoration */}
      <div className="ws-delete-page-glow ws-delete-page-glow-one" />
      <div className="ws-delete-page-glow ws-delete-page-glow-two" />

      <div className="ws-delete-page-container">

        {/* Back */}
        {/* <button
          type="button"
          className="ws-delete-back-btn"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
          <span>Go Back</span>
        </button> */}


        {/* Main Card */}
        <section className="ws-delete-card">

          {/* Header */}
          <div className="ws-delete-header">

            <div className="ws-delete-icon">
              <FaShieldAlt />
            </div>

            <span className="ws-delete-eyebrow">
              ACCOUNT MANAGEMENT
            </span>

            <h1>
              Delete Account
            </h1>

            <p>
              We're sorry to see you go. Please enter the mobile
              number associated with your Winners.in account
              to continue with account deletion.
            </p>

          </div>


          {/* Form */}
          <form
            className="ws-delete-form"
            onSubmit={handleDeleteAccount}
          >

            <div className="ws-delete-field">

              <label htmlFor="delete-mobile">
                Mobile Number
              </label>

              <div className="ws-delete-phone-input">

                <span className="ws-delete-country-code">
                  +91
                </span>

                <input
                  id="delete-mobile"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  placeholder="Enter 10-digit mobile number"
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  maxLength={10}
                  disabled={loading}
                />

              </div>

              <span className="ws-delete-helper">
                Enter the mobile number registered with your account.
              </span>

            </div>


            {/* Warning */}
            <div className="ws-delete-warning">

              <strong>
                Before you continue
              </strong>

              <p>
                Account deletion may permanently remove your
                profile, saved properties, favourites and other
                account-related information. This action may not
                be reversible.
              </p>

            </div>


            {/* Buttons */}
            <div className="ws-delete-actions">

              <button
                type="button"
                className="ws-delete-secondary-btn"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="ws-delete-primary-btn"
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : "Request Account Deletion"}
              </button>

            </div>

          </form>


          {/* Footer text */}
          <div className="ws-delete-security">

            <FaShieldAlt />

            <span>
              Your information is handled securely and only used
              to process your account deletion request.
            </span>

          </div>

        </section>


        {/* Bottom */}
        {/* <p className="ws-delete-page-footer">
          © {new Date().getFullYear()} Winners Realty. All Rights Reserved.
        </p> */}

      </div>

    </main>
  );
};

export default DeleteAccount;